{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified Portuguese-speaking clinical research professional before activating locale=pt in production.",
  "app": {
    "name": "OneVerse",
    "loading": "Carregando...",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "confirm": "Confirmar",
    "submit": "Enviar",
    "edit": "Editar",
    "close": "Fechar",
    "back": "Voltar",
    "next": "Próximo",
    "search": "Pesquisar",
    "filter": "Filtrar",
    "export": "Exportar",
    "yes": "Sim",
    "no": "Não",
    "required": "Obrigatório",
    "optional": "Opcional",
    "none": "Nenhum",
    "unknown": "Desconhecido",
    "error": "Ocorreu um erro. Tente novamente.",
    "powered_by": "Desenvolvido por {{name}}"
  },
  "nav": {
    "home": "Início",
    "dashboard": "Painel",
    "submissions": "Submissões",
    "studies": "Estudos",
    "sites": "Sites",
    "users": "Usuários",
    "settings": "Configurações",
    "notifications": "Notificações",
    "admin": "Administração",
    "help": "Ajuda",
    "sign_out": "Sair",
    "logout": "Sair",
    "expand_sidebar": "Expandir barra lateral",
    "collapse_sidebar": "Recolher barra lateral"
  },
  "auth": {
    "sign_in": "Entrar",
    "sign_in_button": "Entrar",
    "sign_out": "Sair",
    "email": "E-mail",
    "email_placeholder": "Digite seu e-mail",
    "password": "Senha",
    "password_placeholder": "Digite sua senha",
    "forgot_password": "Esqueceu sua senha?",
    "reset_password": "Redefinir senha",
    "enter_reset_code": "Digite o código de redefinição",
    "reset_code_instructions": "Digite seu e-mail e enviaremos um código para redefinir sua senha.",
    "new_code_instructions": "Digite o código e sua nova senha.",
    "send_reset_code": "Enviar código de redefinição",
    "sending": "Enviando...",
    "reset_password_action": "Redefinir senha",
    "resetting": "Redefinindo...",
    "create_account": "Criar conta",
    "welcome": "Bem-vindo ao OneVerse",
    "remember_password": "Lembra sua senha?",
    "confirmation_code": "Código de confirmação",
    "confirmation_code_placeholder": "Digite o código do seu e-mail ou mensagem de texto",
    "new_password": "Nova senha",
    "new_password_placeholder": "Digite sua nova senha",
    "confirm_password": "Confirmar nova senha",
    "confirm_password_placeholder": "Confirme sua nova senha",
    "mfa": {
      "code": "Código",
      "back_to_login": "Voltar ao login",
      "sms_placeholder": "Digite o código enviado para seu telefone",
      "email_placeholder": "Digite o código enviado para seu e-mail",
      "totp_placeholder": "Digite o código do seu aplicativo autenticador"
    },
    "show_password": "Mostrar senha",
    "hide_password": "Ocultar senha",
    "errors": {
      "invalid_credentials": "E-mail ou senha inválidos.",
      "account_locked": "Sua conta foi bloqueada. Entre em contato com o suporte.",
      "session_expired": "Sua sessão expirou. Por favor faça login novamente.",
      "email_required": "E-mail é obrigatório",
      "email_password_required": "E-mail e senha são obrigatórios",
      "all_fields_required": "Todos os campos são obrigatórios",
      "passwords_dont_match": "As senhas não conferem",
      "unexpected": "Ocorreu um erro inesperado",
      "server_non_json": "O servidor retornou uma resposta não-JSON. Verifique o console."
    },
    "welcome_back": "Bem-vindo de volta",
    "subtitle": "Por favor, insira seus dados.",
    "no_account": "Não tem conta?",
    "sign_up": "Cadastrar"
  },
  "dashboard": {
    "welcome": "Bem-vindo, {{name}}",
    "new_submission": "Nova submissão",
    "submission_overview": "Visão geral das submissões",
    "view_all_submissions": "Ver todas as submissões",
    "recent_activity": "Atividade recente",
    "no_recent_activities": "Sem atividade recente.",
    "search_placeholder": "Pesquisar",
    "total": "Total",
    "submission_singular": "submissão",
    "submission_plural": "submissões",
    "active_site_status": "Status do site ativo",
    "view_study": "Ver estudo",
    "loading_studies": "Carregando estudos...",
    "select_study": "Selecionar estudo",
    "view_details": "Ver detalhes",
    "news_and_notes": "Notícias e notas",
    "no_recent_posts": "Sem publicações recentes.",
    "failed_to_load_announcements": "Falha ao carregar anúncios",
    "statuses": {
      "response_required": "Resposta necessária",
      "drafts": "Rascunhos",
      "submitted": "Enviado",
      "pre_review": "Pré-revisão",
      "irb_review": "Revisão IRB",
      "post_review": "Pós-revisão",
      "expiring_soon": "Expirando em breve"
    }
  },
  "submissions": {
    "title": "Submissões",
    "new": "Nova submissão",
    "empty": "Nenhuma submissão encontrada.",
    "status": {
      "pending": "Pendente",
      "under_review": "Em revisão",
      "approved": "Aprovado",
      "rejected": "Rejeitado",
      "revisions_required": "Revisões necessárias",
      "withdrawn": "Retirado",
      "expired": "Expirado",
      "closed": "Fechado",
      "draft": "Rascunho",
      "submitted": "Enviado",
      "pre_review": "Pré-revisão",
      "irb_review": "Revisão IRB",
      "post_review": "Pós-revisão",
      "response_required": "Resposta necessária",
      "expiring_soon": "Expirando em breve",
      "complete": "Concluído",
      "deleted": "Excluído"
    },
    "fields": {
      "title": "Título",
      "protocol_number": "Número do protocolo",
      "principal_investigator": "Investigador principal",
      "submitted_at": "Enviado em",
      "updated_at": "Última atualização",
      "status": "Status",
      "type": "Tipo",
      "id": "ID",
      "submitted": "Enviado",
      "expiration": "Data de expiração"
    },
    "actions": {
      "view": "Ver submissão",
      "edit": "Editar submissão",
      "withdraw": "Retirar",
      "submit": "Enviar para revisão"
    },
    "empty_yet": "Nenhuma submissão ainda.",
    "search_placeholder": "Buscar por ID ou título",
    "filter": {
      "all_statuses": "Todos os status",
      "all_types": "Todos os tipos",
      "status_label": "Status",
      "type_label": "Tipo"
    },
    "errors": {
      "failed_to_load": "Falha ao carregar as submissões"
    }
  },
  "studies": {
    "title": "Estudos",
    "new": "Novo estudo",
    "empty": "Nenhum estudo encontrado.",
    "fields": {
      "title": "Título do estudo",
      "irb_number": "Número IRB",
      "pi": "Investigador principal",
      "status": "Status",
      "start_date": "Data de início",
      "end_date": "Data de fim",
      "id": "ID",
      "type": "Tipo",
      "submitted": "Enviado",
      "expiration": "Data de expiração"
    },
    "empty_yet": "Nenhum estudo ainda.",
    "search_placeholder": "Buscar por ID ou título",
    "filter": {
      "all_statuses": "Todos os status",
      "all_types": "Todos os tipos",
      "type_label": "Tipo",
      "attribute_label": "Atributo",
      "all_attributes": "Todos os atributos",
      "attribute_value_placeholder": "Valor do atributo"
    },
    "errors": {
      "failed_to_load": "Falha ao carregar os estudos"
    },
    "standalone": "independente",
    "sort_by": "Ordenar por {{column}}",
    "attributes": {
      "cro": "CRO",
      "sponsor": "Patrocinador",
      "pi": "PI",
      "pi_email": "Email do PI",
      "poc": "POC",
      "poc_email": "Email do POC",
      "poc_phone": "Telefone do POC",
      "poc_role": "Função do POC"
    }
  },
  "sites": {
    "title": "Sites",
    "new": "Novo site",
    "empty": "Nenhum site encontrado.",
    "empty_yet": "Nenhum site ainda.",
    "search_placeholder": "Buscar por ID, nome do site ou PI",
    "filter": {
      "all_statuses": "Todos os status",
      "all_countries": "Todos os países",
      "country_label": "País"
    },
    "errors": {
      "failed_to_load": "Falha ao carregar os sites"
    },
    "fields": {
      "id": "ID",
      "site_name": "Nome do site",
      "country": "País",
      "protocol_number": "Número do protocolo",
      "sponsor_name": "Nome do patrocinador",
      "pi_name": "Nome do PI",
      "approved": "Aprovado",
      "expiration": "Data de expiração",
      "status": "Status"
    }
  },
  "errors": {
    "not_found": "O recurso solicitado não foi encontrado.",
    "unauthorized": "Você não está autorizado a realizar esta ação.",
    "server_error": "Ocorreu um erro no servidor. Tente novamente mais tarde.",
    "network_error": "Ocorreu um erro de rede. Verifique sua conexão.",
    "not_found_title": "Perdemos esta página",
    "not_found_body": "A página que você procura não existe ou foi movida.",
    "go_back": "Voltar"
  },
  "pagination": {
    "previous": "Anterior",
    "next": "Próximo",
    "page": "Página {{current}} de {{total}}",
    "showing": "Exibindo {{from}}–{{to}} de {{total}}"
  },
  "dates": {
    "today": "Hoje",
    "yesterday": "Ontem",
    "just_now": "Agora mesmo",
    "ago": "Há {{time}}"
  },
  "entity": {
    "status": {
      "in_progress": "Em andamento",
      "active": "Ativo",
      "rejected": "Rejeitado",
      "suspended": "Suspenso",
      "closed": "Fechado",
      "expired": "Expirado"
    }
  },
  "activities": {
    "submission_approved": "Submissão aprovada",
    "submission_created": "Submissão criada",
    "submission_submitted": "Submissão enviada",
    "submission_updated": "Submissão atualizada",
    "submission_withdrawn": "Submissão retirada",
    "submission_rejected": "Submissão rejeitada",
    "submission_expired": "Submissão expirada",
    "study_created": "Estudo criado",
    "study_updated": "Estudo atualizado",
    "site_created": "Site criado",
    "site_updated": "Site atualizado",
    "status_changed": "Status alterado",
    "review_started": "Revisão iniciada",
    "review_completed": "Revisão concluída",
    "comment_added": "Comentário adicionado",
    "document_uploaded": "Documento enviado",
    "response_required": "Resposta necessária"
  }
}
